module.exports = __webpack_public_path__ + "img/y_box.d5527358.png";